import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { BasisDocumentFileTemplateKeyService } from '@zaoblako/web/core/services/basis/basis-document-file-template-key.service';
import { TreeSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/tree-select/tree-select.component';
import { DocumentFileTemplateKeyTargetChildrenFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-target-children-find.dto';

@Component({
  selector: 'crm-document-file-template-key-target-single-select',
  standalone: true,
  imports: [TreeSelectComponent],
  templateUrl: './document-file-template-key-target-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFileTemplateKeyTargetSingleSelectComponent implements OnInit {
  public options: DocumentFileTemplateKeyTargetChildrenFindInterface[] = [];

  @Input() public selectedTarget: DocumentFileTemplateKeyTargetChildrenFindInterface;
  @Output() public selectedTargetChange = new EventEmitter<DocumentFileTemplateKeyTargetChildrenFindInterface>();

  @Input() public set target(target: string) {
    this._target = target;
    if (this.options?.length) {
      this.parseSelectedTarget();
    }
  }

  private _target: string;

  @Input() public isFloatLabel = false;
  @Input() public appendTo: any;
  @Input() public showClear = false;
  @Input() public isError = false;

  public constructor(
    private readonly basisDocumentFileTemplateKeyService: BasisDocumentFileTemplateKeyService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.basisDocumentFileTemplateKeyService.getAvailableTargets().subscribe({
      next: (targets) => {
        this.options = targets;
        if (this._target) {
          this.parseSelectedTarget();
        }
        this.cdRef.markForCheck();
      }
    });
  }

  public changeSelectedTarget(target: any) {
    this.selectedTargetChange.emit(target);
  }

  private parseSelectedTarget() {
    const parseChildren = (targets: DocumentFileTemplateKeyTargetChildrenFindInterface[]) => {
      if (!targets?.length) {
        return;
      }

      for (const target of targets) {
        if (target.target === this._target) {
          this.selectedTarget = target;
          this._target = null;
          return;
        }

        if (target.children?.length) {
          parseChildren(target.children);
        }
      }
    };

    parseChildren(this.options);
  }
}
